/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Import_Untitled_NameInputs */

const en_work_order_import_untitled_name = /** @type {(inputs: Work_Order_Import_Untitled_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untitled`)
};

const fr_work_order_import_untitled_name = /** @type {(inputs: Work_Order_Import_Untitled_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sans titre`)
};

const de_work_order_import_untitled_name = /** @type {(inputs: Work_Order_Import_Untitled_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohne Titel`)
};

const it_work_order_import_untitled_name = /** @type {(inputs: Work_Order_Import_Untitled_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senza titolo`)
};

const ru_work_order_import_untitled_name = /** @type {(inputs: Work_Order_Import_Untitled_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Без названия`)
};

const es_work_order_import_untitled_name = /** @type {(inputs: Work_Order_Import_Untitled_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intitulado`)
};

const zh_cn2_work_order_import_untitled_name = /** @type {(inputs: Work_Order_Import_Untitled_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无题`)
};

const ja_work_order_import_untitled_name = /** @type {(inputs: Work_Order_Import_Untitled_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無題`)
};

const hi_work_order_import_untitled_name = /** @type {(inputs: Work_Order_Import_Untitled_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शीर्षकहीन`)
};

const pt_pt2_work_order_import_untitled_name = /** @type {(inputs: Work_Order_Import_Untitled_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem título`)
};

/**
* | output |
* | --- |
* | "Untitled" |
*
* @param {Work_Order_Import_Untitled_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_import_untitled_name = /** @type {((inputs?: Work_Order_Import_Untitled_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Import_Untitled_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_import_untitled_name(inputs)
	if (locale === "de") return de_work_order_import_untitled_name(inputs)
	if (locale === "it") return it_work_order_import_untitled_name(inputs)
	if (locale === "ru") return ru_work_order_import_untitled_name(inputs)
	if (locale === "es") return es_work_order_import_untitled_name(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_import_untitled_name(inputs)
	if (locale === "ja") return ja_work_order_import_untitled_name(inputs)
	if (locale === "hi") return hi_work_order_import_untitled_name(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_import_untitled_name(inputs)
	return en_work_order_import_untitled_name(inputs)
});